



























import API from '@core/services/API'
import { inject } from 'inversify-props'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppDialog from '@core/components/AppDialog.vue'

@Component({
  components: {
    AppDialog
  }
})
export default class RequestResetPassword extends Vue {
  @inject()
  private $api: API

  protected resetForm = false
  protected userName = null
  protected error = null
  protected email = null

  get disabled () {
    return !this.userName || this.userName.length === 0
  }

  showResetForm () {
    this.resetForm = true
  }

  @Watch('resetForm')
  formToggle (sf) {
    if (!sf) {
      this.userName = null
      this.email = null
      this.error = null
    }
  }

  requestReset () {
    this.error = null
    if (!this.userName || this.userName.length === 0) return
    this.$api.account.getToken({
      username: this.userName
    }).then(res => {
      if (res && res.error) {
        this.error = res.error
        return
      }
      this.email = res?.sent
    })
  }
}
